export default __webpack_public_path__ + "icon_emission.2cd2a3e968d8ff5a5c8544d23fa3fcc5.svg";